// EmailCompose.jsx
import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/EmailCompose.module.css";

const EmailCompose = ({ setStep }) => {
  // The text that will be "typed out"
  const initialEmailText =
    "Hi, I'm interested in this unit. Can you let me know if I qualify?";

  // Local state for the typing effect
  const [typedText, setTypedText] = useState("");
  const [typingFinished, setTypingFinished] = useState(false);
  const timeoutsRef = useRef([]);


  useEffect(() => {

    // Reset state when this component mounts
    setTypedText("");
    setTypingFinished(false);
	
	
	
    let index = 0;
    const interval = setInterval(() => {
      if (index < initialEmailText.length) {
        const char = initialEmailText.charAt(index);
		
		if (char !== undefined) {
          setTypedText((prev) => prev + char);
          index++;
        } else {
          clearInterval(interval);
          setTypingFinished(true);
        }
		
      } else {
        clearInterval(interval);
        setTypingFinished(true);
      }
    }, 45);

    timeoutsRef.current.push(interval);

    return () => {
      // Cleanup any pending timers on unmount
      timeoutsRef.current.forEach((timer) => clearInterval(timer));
      timeoutsRef.current = [];
    };
  }, [initialEmailText]);

  const handleChange = (e) => {
    // Allow editing only after the typing effect is done
    if (typingFinished) {
      setTypedText(e.target.value);
    }
  };

  return (
    <div className={styles.composeContainer}>
      <div className={styles.emailHeader}>
        <div className={styles.headerBar}>
          <span className={styles.emailIcon}>📧</span>
          <h3>New Message</h3>
        </div>
        <div className={styles.emailField}>
          <label>To:</label>
          <input
            type="text"
            className={styles.emailInput}
            value="mike@landlordcorp.com"
            readOnly
          />
        </div>
        <div className={styles.emailField}>
          <label>Subject:</label>
          <input
            type="text"
            className={`${styles.emailInput} ${styles.subjectLine}`}
            value="Fenway Fields Apartment Inquiry"
            readOnly
          />
        </div>
      </div>

      <textarea
        className={styles.emailTextarea}
        value={typedText}
        onChange={handleChange}
        placeholder="Composing your email..."
      />

      <div className={styles.emailActions}>
        <button
          className={styles.sendEmailButton}
          onClick={() => setStep(3)}
          disabled={!typingFinished}
        >
          {typingFinished ? "📤 Send Email" : "Typing..."}
        </button>
      </div>
    </div>
  );
};

export default EmailCompose;
